import React, { useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { iThumbdoc } from '../../managers/interfaces'
import ManagersContext from '../../containers/ManagersContext'
import funride from '../../lib/funride/funride.module.less'
const titleCss = 'color:#000000; font-size:13px; font-family:Verdana, Arial, Helvetica, sans-serif; overflow:hidden; font-weight: normal;line-height: 19px;'

interface InnerClientGalleryProps {
    client: string
}
export default function InnerClientGallery (props:InnerClientGalleryProps) {
  const {objPortfolio} = useContext(ManagersContext)
  const clientObj = objPortfolio.clients[props.client]
  const thumbdocs = clientObj.thumbdocs // ThumbDocs are the thumb images for the projects slideshow

  useEffect(() => {
    // For some reason <InnerPageMusic> doesn't need this, but this component does. ?!
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wwindow = window as any // "window.$" gets typescript error.  Solution found here: https://bit.ly/3q8zmHO
    wwindow.$('.html5lightbox').html5lightbox()
  })
  return (
    <div>
      <Helmet>
        <title>Greg Sandell Portfolio - {props.client}</title>
      </Helmet>
      <h1>{clientObj.linkText}</h1>
      <dl>
        <dt>Samples</dt>
        <dd>
          {/*ThumbDocs are the thumb images for the projects slideshow*/}
          {thumbdocs.map((thumbdoc:iThumbdoc, i:number) => {
            const hrefPath = /youtu\.be/.test(thumbdoc.image) ? thumbdoc.image : require('' + thumbdoc.image)
            return (
              <a
                style={{cursor: 'pointer'}}
                href={hrefPath}
                key={`thumb_${props.client}_${i}`}
                data-thumbnail={require('' + thumbdoc.thumbImage)}
                className='html5lightbox'
                data-width={thumbdoc.width}
                data-height={thumbdoc.height}
                data-titlecss={titleCss}
                data-thumbwidth='150' data-thumbheight='150'
                data-autoslide='true' data-shownavigation='false'
                data-group='set8'
                title={thumbdoc.description}
              >
                <img src={require('' + thumbdoc.thumbImage)} className={funride.galleryThumb} />
              </a>
            )
          }
          )}
          <p className={funride.smallComment}>(Click on a thumbnail for more detail)</p>
          <br />
        </dd>
      </dl>
      <InnerClientDescription client={props.client} />
    </div>
  )
}

interface iInnerClientDescriptionProps {
    client: string
}
const InnerClientDescription = (props:iInnerClientDescriptionProps) => {
  const {objResume} = useContext(ManagersContext)
  if (objResume.resume.getPosition(props.client)) {
    const position = objResume.resume.getPosition(props.client)
    const engagementDetails = position?.engagementDetails ? position.engagementDetails : ''
    const listTextArray = position?.listTextArray ? position.listTextArray : []
    return (
      <div>
        <header>
          <h1>Engagement Details</h1>
          <p>
            <span dangerouslySetInnerHTML={{ __html: engagementDetails }} />
                  &nbsp;<a
              href='#testContent'
              style={{fontStyle: 'italic'}}
              className='html5lightbox' data-width='400' data-height='300'>More...</a>
          </p>
        </header>
        {/* Do not try to move these inline CSS styling below into an external file.  HtmlLightbox needs it inline. */}
        {/*  TODO Move this inline style to funride*/}
        <div id='testContent' style={{ display: 'none', padding: '5px' }}>
          <h1 className={funride.engagement}>{props.client} Engagement Details</h1>
          {/*  TODO Move this inline style to funride*/}
          <ul style={{ padding: '0px', listStylePosition: 'outside', listStyleType: 'disc' }}> {
            // TODO Move this inline style to funride
            listTextArray.map((text:string, i:number) => (
              <li
                key={`text_${i}`}
                style={{ padding: '0px 0px 5px 0px', textAlign: 'left' }}
                dangerouslySetInnerHTML={{ __html: '&bull; ' + text }}
              />
            ))
          }
          </ul>
        </div>
      </div>
    )
  } else {
    return null
  }
}
